import styled from 'styled-components'

import { colors } from 'styles/colors'
import { mobile } from 'styles/responsive'

import Accordion from 'components/Accordion/Accordion'

export const Content = styled.div`
    display: flex;
    flex-direction: column;

    margin: 50px 0;

    > * + * {
        margin-top: 40px;
    }

    ${mobile(`
        margin-top: 0;
    `)}
`

export const List = styled.div`
    padding: 0;
    width: 100%;
    border-top: 2px solid ${colors.grayLight};

    > :not(:last-child) {
        border-bottom: 2px solid ${colors.grayLight};
    }

    ${mobile(`
        border-top: none;
        > :not(:last-child) {
            border-bottom: none;
        }

        > :not(:last-child) .Accordion__desc {
            border-bottom: 2px solid ${colors.gray_D7};
        }
    `)}
`

export const AccordionText = styled.span`
    color: ${colors.gray_50};
`

export const Title = styled.h1`
    font-size: 40px;
    font-weight: 700;
    line-height: 36px;

    color: ${({ $color }) => $color};

    ${mobile(`
        font-size: 32px;
    `)}
`

export const StyledAccordion = styled(Accordion)`
    ${mobile(`
        .Accordion__title {
            font-size: 16px;
            text-align: left;
            margin: 0 20px;
        }

        .Accordion__desc {
            margin: 0 20px;

            div {
                color: #505050;
                font-size: 15px;
                padding: 10px 0;
            }
        }
    `)}
`
